const WISHLIST_KEY = 'wishlist';
const attachedButtons = new WeakSet();

function getWishlist() {
  try {
    const data = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    // 旧形式（文字列配列）を新形式に変換
    if (data.length > 0 && typeof data[0] === 'string') {
      return data.map((id) => ({ id, handle: '' }));
    }
    return data;
  } catch (e) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function toggleWishlist(productId, productHandle) {
  const wishlist = getWishlist();
  const index = wishlist.findIndex((item) => item.id === productId);
  if (index === -1) {
    wishlist.push({ id: productId, handle: productHandle || '' });
  } else {
    wishlist.splice(index, 1);
  }
  saveWishlist(wishlist);
}

function updateButtons() {
  const wishlist = getWishlist();
  document.querySelectorAll('.wishlist-btn').forEach((btn) => {
    const id = btn.dataset.productId;
    const isActive = wishlist.some((item) => item.id === id);
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-pressed', String(isActive));
    btn.setAttribute('aria-label', isActive ? 'お気に入りから削除' : 'お気に入りに追加');
    const label = btn.querySelector('.wishlist-btn__label');
    if (label) {
      const newText = isActive
        ? (btn.dataset.labelRemove || 'お気に入りから削除')
        : (btn.dataset.labelAdd || 'お気に入りに追加');
      if (label.textContent !== newText) label.textContent = newText;
    }
  });
}

function updateCount() {
  const count = String(getWishlist().length);
  document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
    if (badge.textContent !== count) badge.textContent = count;
    badge.hidden = count === '0';
  });
}

function attachButton(btn) {
  if (attachedButtons.has(btn)) return;
  attachedButtons.add(btn);
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn.dataset.productId, btn.dataset.productHandle || '');
    updateButtons();
    updateCount();
  });
}

function attachAllButtons() {
  document.querySelectorAll('.wishlist-btn').forEach(attachButton);
}

window.addEventListener('storage', (e) => {
  if (e.key !== WISHLIST_KEY) return;
  updateButtons();
  updateCount();
});

document.addEventListener('DOMContentLoaded', () => {
  attachAllButtons();
  updateButtons();
  updateCount();

  const observer = new MutationObserver(() => {
    attachAllButtons();
    updateButtons();
    updateCount();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
